import type { PlainDate } from "@kedaat/engine";

/** A Hebrew year and month, as KosherJava numbers them: Nisan = 1 … Adar II = 13. */
export interface YearMonth {
  year: number;
  /** 1-13 */
  month: number;
}

export function parseYearMonth(text: string | null): YearMonth | null {
  const match = /^(\d{4})-(\d{2})$/.exec(text ?? "");
  if (!match) return null;
  const month = Number(match[2]);
  return month >= 1 && month <= 13 ? { year: Number(match[1]), month } : null;
}

export function formatYearMonth({ year, month }: YearMonth): string {
  return `${year}-${String(month).padStart(2, "0")}`;
}

const utc = (d: PlainDate) => Date.UTC(d.year, d.month - 1, d.day);
const narrowWeekdayFormat = new Intl.DateTimeFormat("he-IL", {
  weekday: "narrow",
  timeZone: "UTC",
});
const longWeekdayFormat = new Intl.DateTimeFormat("he-IL", { weekday: "long", timeZone: "UTC" });
const gregorianRangeFormat = new Intl.DateTimeFormat("he-IL", {
  day: "numeric",
  month: "long",
  year: "numeric",
  timeZone: "UTC",
});

/** 0 for Sunday through 6 for Shabbat. */
export function weekdayIndex(date: PlainDate): number {
  return new Date(utc(date)).getUTCDay();
}

export function narrowWeekday(date: PlainDate): string {
  return narrowWeekdayFormat.format(utc(date));
}

/** e.g. "יום שישי" */
export function weekdayName(date: PlainDate): string {
  return longWeekdayFormat.format(utc(date));
}

/** The civil dates a Hebrew month spans, e.g. "12 בספטמבר 2026 – 11 באוקטובר 2026". */
export function gregorianRange(first: PlainDate, last: PlainDate): string {
  return `${gregorianRangeFormat.format(utc(first))} – ${gregorianRangeFormat.format(utc(last))}`;
}
